import { assign, createMachine } from 'xstate'

import { NavigationItemWithChildren } from 'components/front-end/Header/navigationHelpers'
import { ScrollDirectionChangeEvent, scrollDirectionMachine } from './scrollDirection.machine'

type NavItem = NavigationItemWithChildren
type ActivePath = NavItem[]

export const navigationMachine = createMachine(
  {
    //** @xstate-layout N4IgpgJg5mDOIC5SwJYBcwDkCGA3FU2aKA9gHYDEAkpgCoCiASgIIDCtA+gAqNUCyzRgE0OmZgDUA2gAYAuolAAHEqmLkFIAB6IAzADYATADoArAA4zBnWfPSA7ABYDBvQBoQAT0QBaHQ5NGZgCMJiYOetJ6EQ5BZnoAvvHuqlh4BESklGy0VOLMDBwAyvSCrAASMvJIIMqqmRraCN520sZ6DgCcQXZmHZ0GQbHuXk0O0tKmhnp2ejrWDp16JonJ6Kn4hGpZ7Ln59KISVADi+VQA8piVGrXo9dWNdnZGgz3SDmbWenEmdsM+fgFgqFwpForEEkkQCkcBsMuQKMVOGJxMdThcOAARfLMK7VG5bBo+Hp6Z4uKJfcYdaRmBx-Jp6IIOQI6EwM-wmEImDoQ1YYGHpLZGFAQAA2YAotDORyOABl9sVShU5NcVLd1PcfO8SdIdB0dC0WjpnO86d4DB0OoE+qygh0fmFzSsoWt+ZtMkLReLJdK5QcUScchdcUpVQSNU0rMZ-HaxnYOnYjXGDKaDHYgkYjeMWW8GRbWU7oWk3eQPWKjGQi3CyAAhbAAJ3EKFQACMxQjWIwzjKZZiqIx6Dt0eVmJgjvQMcGaqG7qBGt4vmZnjZGXM7CY5gZaZ5EC8jNNxkEXDqguNnAWXZXBcKyxXYVta3WysKIGBKIUO12exi+wPA5gOMOo7jpO+IzloPh6joRjOAYXLLtmLJ0ragLrqyOjSCELKdMskKFne7rYAAxsQuBEJAFAYiUOx5AUyKon+IHTuqs6agyRh6gY0hdLB9g0oydLvEyhiMrMRodL09g6OefKXgRxEoKRGAQBQcoSPsdEBuclzKniTFkISEYTB0zhcfMuo6tYOhIdS0G2pYonvBaPLOjJ+ElkRJFkcpXBnFwfr0VpjF1Mx4H0iEGbTIeXQ6N0xlmHSthGGmGGtAsYSWFJuEXm5ZBGB5CleRKUqyuphyaUGOkhsF+nht4cRQZJdqbqmDI9HSehUkYoKLB87Q9JlvLrAKcmeUppbikFao1SxCAchMJicQt5hhCY9i-NuCCdEY4TWGmEkMlYzl4cN7nyYpkBGLAYCEeQED1h4MLMGdhU0AwLDsEUA4XFiwh+pNYYzY8lopWYrRca0XJuBt85JXafjxj87zrtIOGDa6VZ5c9Y1XTdZB3XWD14E9o3kT5fkaWi2lVFVU0GSe66mEaAyssEcwhNZEw0s4MWWG8jKptJQ3Frl+XnRAl3Xbd92PVjF3XhNlVTtVBl2Ju23iR8kb6nM8UbQsUFBPojLmOh5o0kd2UnSLsvizjUsEzLJPixgdbENLRM29QdBMNkHBvTkggiMi-1gY08bptYHLRbzerrSMnRQQmURBB1HxrtyA0uULGOi15Eu4-jhO4MTBVjS7bsOx7TsUGT-nlVTKrK+GgxmE8CZRRYSwYar7UYaY5hw1xlgtBbrlW5jTtGC+ufEGQUAUP29De4wdeUyHIVh08KMOO3UQoxyusjH4TwDHGDJvK3fQJoL6OCjPF3T1jKBzwv9BL29q8MUE1NK7TzcJoEaYcwATdAiGEOkVgGpg3sPTBa7RUZZ1viNUuD8wAz2fvPTQsA0BkTygAMxdgACnQtIAAlBQY6wsJ4oPFo-UaGD17TVCmaGyrc3irXsFxRwJg6R+EXGmOMqt9QcmcEEG+skSxXXrIRAAFhRKiOQaLyhKIwcojCDLNEPHuGI2YqSzCWIfHwVgJhrlbmuFqjhBgGHETlCW0i5HehKp9RU6jaqtyZIyBMZsdTGXMCmC0Vp2T6n1haOYiRIRkBIC+eA1RKFVkbn-Ga3gTzmmgs4OCHIEI8Ohu8RckQXDmEgcEBYNjx7ywSQDZh4l0wwQyYbVaiFoaMnTK0DWFpbSHlBg4UpVD5blgkTWesjYWxigqaHIkfdDzI0iGJawyYNrWG2i0akPQujtCWD0jGfTbxWwfE+CAL4mGgQ3j4eysM3i6m6JmHevD7DMl6O0LCMyzCbLvjbMZJz6SLmMpxPUNJzI61NIbfhcMB5d1VmuV5yCxbjQ+UwxoRoDYUgwk4GYsUBLGAsDFEIAwHDoXQh0KFp1J52zxu7Yu7zdJNxmuSUwOo8UxTTD8PwEDDbPEeDvHMnFW7dCJdbElksyWVwpZPcpVLEmhVBi0-UvRHisgTPGXh-h2WODPh1aY4QEFxLeQKgu5KS4wvLigfVlKaaVIeIyOlfg2ZMoTFuEY5gmQLR1GDCIqsU58uoTCuhpcMFwo0SeLqThmqRHDhhLoEC5hdWgSEGkXFQgvKymPKhUi6yyP9bVJYTxjJM0+C0OIQR-GWl6P4PwbxsIsnCfEIAA */
    schema: {
      events: {} as
        | { type: 'SET_NAVIGATION_DATA'; data: NavItem[] }
        | { type: 'HIDE_NAVIGATION_BAR' }
        | { type: 'REVEAL_NAVIGATION_BAR' }
        | { type: 'INTERACT_PRIMARY_NAV'; item: NavItem }
        | { type: 'INTERACT_SECONDARY_NAV'; item: NavItem }
        | { type: 'INTERACT_TERTIARY_NAV'; item: NavItem }
        | { type: 'LEAVE_NAVIGATION' }
        | { type: 'ACTIVATE_NAVIGATION' }
        | { type: 'REENTER_NAVIGATION' }
        | { type: 'DEACTIVATE_NAVIGATION' }
        | { type: 'TOGGLE_NAVIGATION' }
        | { type: 'POP_NAVIGATION' }
        | { type: 'ACTIVATE_SEARCH' }
        | { type: 'DEACTIVATE_SEARCH' }
        | { type: 'TOGGLE_SEARCH' }
        | { type: 'SCROLL_DIRECTION_CHANGED'; direction: 'up' | 'down' }
        | { type: 'LOCK_TRAP' }
        | { type: 'UNLOCK_TRAP' }
        | { type: 'done.invoke.parseNavFields' }
        | { type: 'error.platform.parseNavFields' }
        | ScrollDirectionChangeEvent,
      services: {} as {
        watchScrollDirection: { data: 'up' | 'down' }
      },
    },

    id: 'siteNavigation',
    type: 'parallel',
    context: {
      activePath: [] as ActivePath | [],
      navItems: [] as NavItem[]
    },

    states: {
      focusTrap: {
        id: 'focus-trap',
        initial: 'unlocked',
        states: {
          locked: {
            on: {
              UNLOCK_TRAP: 'unlocked',
            }
          },
          unlocked: {
            on: {
              LOCK_TRAP: 'locked',
            }
          }
        }
      },
      nav: {
        id: 'nav',
        initial: 'idle',
        states: {
    
          idle: {
            invoke: {
              src: 'watchScrollDirection',
              id: 'watchScrollDirection',
            },
    
            initial: 'navigationBarVisible',
            entry: ['clearActivePath'],
    
            states: {
              navigationBarVisible: {
                on: {
                  SCROLL_DIRECTION_CHANGED: {
                    target: '#siteNavigation.nav.idle.navigationBarHidden',
                    cond: 'isScrollingDown',
                    internal: true,
                  },
                },
              },
    
              navigationBarHidden: {
                description: `This is the only state where the navigation bar should be hidden.`,
                on: {
                  SCROLL_DIRECTION_CHANGED: {
                    target: '#siteNavigation.nav.idle.navigationBarVisible',
                    cond: 'isScrollingUp',
                    internal: true,
                  },
                },
              },
            },
    
            on: {
              TOGGLE_SEARCH: 'search',
              TOGGLE_NAVIGATION: {
                target: 'activated',
                actions: 'clearActivePath',
              },
            },
          },
    
          activated: {
            initial: 'idle',
    
            states: {
              idle: {
                always: [{ target: 'secondaryNavActivated', cond: 'primaryItemHasChildren' }],
              },
    
              secondaryNavActivated: {
                initial: 'idle',
    
                states: {
                  idle: {
                    always: [{ target: 'tertiaryNavActivated', cond: 'secondaryItemHasChildren' }],
                  },
    
                  tertiaryNavActivated: {
                    on: {
                      INTERACT_TERTIARY_NAV: {
                        actions: 'setActivePath',
                      },
    
                      POP_NAVIGATION: {
                        target: '#siteNavigation.nav.activated.secondaryNavActivated',
                        actions: 'popActivePath',
                      },
                    },
    
                    description: `Reveal the third-level nav menu.`,
                  },
                },
    
                on: {
                  INTERACT_SECONDARY_NAV: {
                    target: 'secondaryNavActivated',
                    actions: 'setActivePath',
                  },
    
                  POP_NAVIGATION: {
                    target: '#siteNavigation.nav.activated',
                    actions: 'popActivePath',
                  },
                },
    
                description: `Reveal the second-level nav menu.`,
              },
    
              deactivating: {
                on: {
                  REENTER_NAVIGATION: [
                    {
                      target: 'secondaryNavActivated.idle',
                      cond: 'secondaryItemSet',
                    },
                    'idle',
                  ],
                },
                after: {
                  '300': '#siteNavigation.nav.idle',
                },
              },
            },
    
            on: {
              DEACTIVATE_NAVIGATION: 'idle',
              LEAVE_NAVIGATION: { target: '.deactivating', internal: true },
    
              POP_NAVIGATION: {
                target: 'idle',
                actions: 'popActivePath',
              },
    
              TOGGLE_NAVIGATION: {
                target: 'idle',
                actions: ['clearActivePath'],
              },
            },
    
            description: `Reveal the modal backdrop.`,
          },
    
          search: {
            on: {
              DEACTIVATE_SEARCH: 'idle',
              TOGGLE_SEARCH: 'idle',
            },
          },
        },
        on: {
          INTERACT_PRIMARY_NAV: {
            target: '.activated',
            actions: 'setActivePath',
          },
    
          ACTIVATE_SEARCH: '.search',
    
          ACTIVATE_NAVIGATION: {
            target: '.activated',
            actions: 'clearActivePath',
          },
    
          SET_NAVIGATION_DATA: {
            target: '#siteNavigation.nav',
            internal: true,
            actions: 'setNavItems',
          },
        },
      }
    },
    tsTypes: {} as import('./siteNavigation.machine.typegen').Typegen0,
    preserveActionOrder: true,
    predictableActionArguments: true,
  },
  {
    actions: {
      setActivePath: assign({
        activePath: ({ activePath }, evt) => {
          switch (evt.type) {
            case 'INTERACT_PRIMARY_NAV':
              return [evt.item]
            case 'INTERACT_SECONDARY_NAV':
              return [...activePath.slice(0, 1), evt.item]
            case 'INTERACT_TERTIARY_NAV':
              return [...activePath.slice(0, 2), evt.item]
            default:
              return activePath
          }
        },
      }),
      popActivePath: assign({
        activePath: ({ activePath }) => activePath.slice(0, -1),
      }),
      clearActivePath: assign({ activePath: [] }),
      setNavItems: assign({
        navItems: ({ navItems }, evt) => {
          if (JSON.stringify(evt.data) !== JSON.stringify(navItems)) {
            return evt.data
          }
          return navItems
        },
      }),
    },
    guards: {
      primaryItemHasChildren: ({ activePath }) =>
        activePath.length === 1 && 'children' in activePath[0] && activePath[0].children.length > 0,
      secondaryItemHasChildren: ({ activePath }) =>
        activePath.length === 2 && 'children' in activePath[1] && activePath[1].children.length > 0,
      secondaryItemSet: ({ activePath }) => activePath.length > 1,
      isScrollingUp: (_, { direction }) => direction === 'up',
      isScrollingDown: (_, { direction }) => direction === 'down',
    },
    services: {
      watchScrollDirection: scrollDirectionMachine,
    },
  }
)
